export const ROUTES = {
  home: "/sales-enablement/my-marketing-materials",
  create: (id: string) => `/sales-enablement/my-marketing-materials/new/${id}`,
  edit: (id: string) => `/sales-enablement/my-marketing-materials/${id}`,
  emailDelivery: (id?: string) =>
    id
      ? `/sales-enablement/my-marketing-materials/send-by-email/${id}`
      : `/sales-enablement/my-marketing-materials/send-by-email`,

  emailDeliveryEditing: (id: string) =>
    `/sales-enablement/my-marketing-materials/${id}/send-by-email`,
  print: (id?: string) =>
    id
      ? `/sales-enablement/my-marketing-materials/${id}/print`
      : "/sales-enablement/my-marketing-materials/print",
  printCheckout: (id?: string) =>
    id
      ? `/sales-enablement/my-marketing-materials/${id}/print/checkout`
      : "/sales-enablement/my-marketing-materials/print/checkout",
};

export const QUERY_KEYS = {
  marketingMaterials: "marketingMaterials",
  emailRecipients: "emailRecipients",
  deliveries: "deliveries",
  printArchives: "printOrders",
  shippingMethods: "shippingMethods",
};
